export default {
  common: {
    loading: 'Laden...',
    noData: 'Keine Daten verfügbar.',
  },
  nav: {
    home: 'Startseite',
    products: 'Produkt',
    about: 'Über uns',
    partnership: 'Partnerschaft',
    blog: 'Blog',
  },
  home: {
    text: 'STARTSEITE',
    title: 'YOOXPLORE',
    hero: {
      title1: 'Stärkung globaler Partner',
      title2: 'Die Zukunft von oben sichern',
      bookDemo: 'Demo buchen',
    },
  },
  overview: {
    title: 'Übersicht',
    subtitle: 'YOOX S3T UAV-Plattform',
    content: 'Der YOOX S3T ist ein fortschrittliches unbemanntes Luftfahrzeug (UAV), das schwere Lasten tragen, stabil fliegen und präzise manövrieren kann. Es wurde entwickelt, um einer der besten autonomen Drohnen auf dem Markt zu sein, mit langer Flugzeit und hervorragender Langstreckenleistung – ideal für militärische Operationen, industrielle Aufgaben und humanitäre Missionen.',
    content2: 'Neben dem Verkauf von Drohnen helfen wir Ihrer Drohnenmarke, lokal erfolgreich zu sein. Wir bieten lokalisierte Produktions- und Montagelösungen an, um Ihnen beim Aufbau Ihres eigenen Produktionssystems zu helfen und die besten Drohnen herzustellen.',
  },
  scenarios: {
    title: 'Szenarien',
    subtitle: 'Erweiterbar auf weitere industrielle Anwendungsfälle',
  },
  advantages: {
    title: 'Kernvorteile',
    subtitle: 'Entwickelt, um mit Ihren Anforderungen zu skalieren',
  },
  products: {
    title: 'Produktzentrum',
    intro: 'Produkteinführung',
    subtitle: 'Industrielle Flugplattformen und ökologische Produkte',
    gallery: {
      all: 'Alle',
    },
    contact_business: 'Bitte kontaktieren Sie uns für weitere Produktdetails',
  },
  about: {
    text: 'Über uns',
    title: 'Über uns',
    teamTitle: 'Unser Team',
    teamSubtitle: 'Von führenden globalen Unternehmen',
    teamContent: 'Unser Team kommt von Unternehmen wie DJI, Yamaha, Apple, Tesla usw. Wir verfügen über durchschnittlich mehr als zehn Jahre Erfahrung in der Drohnenindustrie sowie in den Bereichen Sicherheit und Verteidigung.',
    visionTitle: 'Unsere Vision',
    visionSubtitle: 'Ihrer Drohnenmarke zum lokalen Erfolg verhelfen',
    visionContent: 'Neben dem Drohnenverkauf bieten wir lokalisierte Produktions- und Montagelösungen an, um Ihnen beim Aufbau Ihres eigenen Produktionssystems zu helfen und die besten Drohnen herzustellen.',
  },
  partnership: {
    title: 'Partnerschaft',
    primaryCta: 'Großhandel & ODM & OEM',
    secondaryCta: 'Händler werden',
    qaTitle: 'Häufig gestellte Fragen',
  },
  blog: {
    title: 'Blog',
    heading: 'Einblicke und Updates',
    subheading: 'Aktuelles zu Drohnen, Lokalisierung und Markttrends.',
    searchPlaceholder: 'Artikel suchen',
  },
  contact: {
    title: 'Kontakt',
    title2: 'Wir würden gerne von Ihnen hören.',
    content1: 'Wenn Sie weitere Informationen oder eine Zusammenarbeit wünschen, kontaktieren Sie uns über WhatsApp, Telegram oder das Formular.',
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
    telegramLabel: 'Telegram',
    telegramValue: 'Telegram: <YOUR_TELEGRAM>',
    form: {
      title: 'Kontaktformular',
      subtitle: 'Wir würden gerne von Ihnen hören.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Unternehmen',
      country: 'Land/Region',
      interestLabel: 'Ich interessiere mich für',
      interests: ['Produktkauf', 'Händler werden', 'OEM/ODM', 'Technische Beratung', 'Sonstiges'],
      message: 'Ihre Bedürfnisse und Beschreibung',
      submit: 'Absenden',
      submitTip: 'Danke für Ihre Kontaktaufnahme. Wir werden uns bald bei Ihnen melden.',
      submitError: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },
  },
}
